module.exports = __webpack_public_path__ + "static/project-17b-c51106fe193bfa71fa425dde7299f394.png";